import React, { useEffect, useRef } from 'react';
import { gerarNumeroParcelas } from './helpers/gerarNumeroParcelas';
import AdyenCheckout from '@adyen/adyen-web';
import apiPagamento from '../../services/backAxiosPagamentoToken';

import '@adyen/adyen-web/dist/adyen.css';
import './adyen-dropin.css';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

export default function DropinAdyen({ valor, onSubmit, valorTotal, subGrupo }) {
    const dropin_container_ref = useRef();
    const valorQuery = {
        value: '2000',
        blockedPayment: ['boletobancario', 'boletobancario_santander', 'pix']
    };

    const opcoesAte4parcelas = [1, 2, 3, 4];
    const arrayDeParcelas =
        subGrupo?.trim() !== 'ZP4' ? gerarNumeroParcelas(valorTotal) : opcoesAte4parcelas;
    const configuration = async () => ({
        paymentMethodsResponse: (
            await apiPagamento.post('/list', valorQuery)
        ).data,
        environment: retornoHashValor(process.env.REACT_APP_6),
        clientKey: retornoHashValor(process.env.REACT_APP_5),
        locale: 'pt-BR',
        'translations': {
            'pt-BR': {
                'creditCard.holderName.placeholder': ' '
            }
        },
        onSubmit,
        onPaymentCompleted: (result, component) => {
            console.info(result, component);
        },
        onError: (error, component) => {
            console.error(error.name, error.message, error.stack, component);
        },
        showPayButton: true,
        amount: {
            currency: 'BRL',
            value: valor
        },
        paymentMethodsConfiguration: {
            card: {
                hasHolderName: true,
                holderNameRequired: true,
                enableStoreDetails: false,
                showPayButton: true,
                installmentOptions: {
                    card: {
                        values: arrayDeParcelas,
                        plans: ['regular']
                    },
                    showInstallmentAmounts: true
                }
            }
        }
    });

    useEffect(() => {
        (async () => {
            const paymentMethods = apiPagamento
                .post('/list', valorQuery)
                .then(response => response.data)
                .catch(err => {
                    console.error(err);
                });

            const checkout = new AdyenCheckout(await configuration(paymentMethods));

            checkout.create('dropin').mount(dropin_container_ref.current);
        })();
    }, [valor]);

    return (
        <>
            <div ref={dropin_container_ref} className="adyen-dropin"></div>
        </>
    );
}
